import { render, staticRenderFns } from "./wastes_or_services_info.vue?vue&type=template&id=135dccfc&"
import script from "./wastes_or_services_info.vue?vue&type=script&lang=js&"
export * from "./wastes_or_services_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports